var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-animate-container',[_c('u-animate',{attrs:{"name":"fadeInUp","delay":"0s","duration":"1s","iteration":1,"offset":0,"animateClass":"animated","begin":false}},[_vm._v("测试")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }